export default "__VITE_ASSET__BR1$YVcg__"